export default __webpack_public_path__ + "media/dislike.24662bf1.svg";